// user/components/ProviderForm.js

import React, { useState } from "react";

export default function ProviderForm({
  providerData,
  onSave,
  onCancel,
  onReInvite
}) {
  const isExisting = !!providerData?.id;
  const estado = providerData?.estado || "pendiente";

  const [formData, setFormData] = useState({
    nombre: providerData?.nombre || "",
    correo: providerData?.correo || "",
    telefono: providerData?.telefono || "",
    tipoServicio: providerData?.tipoServicio || "paseador"
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave?.(formData);
  };

  // Si está rechazado
  if (estado === "rechazado") {
    return (
      <div className="card mb-3 card-elevated" 
           style={{borderRadius: 'var(--radius-xl)'}}>
        <div style={{
          background: 'var(--color-danger)',
          color: 'var(--white)',
          padding: 'var(--space-4)',
          borderRadius: 'var(--radius-xl) var(--radius-xl) 0 0'
        }}>
          <h5 className="mb-0" 
              style={{
                fontSize: 'var(--font-size-xl)',
                fontWeight: 'var(--font-weight-bold)'
              }}>
            <i className="bi bi-x-circle-fill me-2"></i>
            Proveedor Rechazado
          </h5>
        </div>
        <div className="card-body" 
             style={{padding: 'var(--space-4)'}}>
          <p style={{
            fontSize: 'var(--font-size-base)',
            color: 'var(--gray-700)',
            marginBottom: 'var(--space-3)'
          }}>
            Este proveedor rechazó la invitación.
          </p>
          <div style={{
            display: 'flex',
            gap: 'var(--space-2)'
          }}>
            {onReInvite && (
              <button
                className="btn btn-outline-warning transition-base"
                onClick={() => onReInvite(providerData)}
                style={{
                  fontSize: 'var(--font-size-sm)',
                  padding: 'var(--space-2) var(--space-3)'
                }}
              >
                <i className="bi bi-arrow-clockwise me-2"></i>
                Volver a Invitar
              </button>
            )}
            <button 
              className="btn btn-secondary transition-base" 
              onClick={onCancel}
              style={{
                fontSize: 'var(--font-size-sm)',
                padding: 'var(--space-2) var(--space-3)'
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Si está verificado
  if (estado === "verificado") {
    return (
      <div className="card mb-3 card-elevated" 
           style={{borderRadius: 'var(--radius-xl)'}}>
        <div style={{
          background: 'var(--color-success)',
          color: 'var(--white)',
          padding: 'var(--space-4)',
          borderRadius: 'var(--radius-xl) var(--radius-xl) 0 0'
        }}>
          <h5 className="mb-0" 
              style={{
                fontSize: 'var(--font-size-xl)',
                fontWeight: 'var(--font-weight-bold)'
              }}>
            <i className="bi bi-check-circle-fill me-2"></i>
            Proveedor Verificado
          </h5>
        </div>
        <div className="card-body" 
             style={{padding: 'var(--space-4)'}}>
          <p style={{
            fontSize: 'var(--font-size-base)',
            color: 'var(--gray-700)',
            marginBottom: 'var(--space-3)'
          }}>
            <strong style={{fontWeight: 'var(--font-weight-semibold)'}}>
              {providerData.nombre}
            </strong> ya está verificado y puede recibir recordatorios.
          </p>
          <div className="alert alert-info rounded-lg"
               style={{
                 fontSize: 'var(--font-size-sm)',
                 padding: 'var(--space-3)',
                 borderRadius: 'var(--radius-md)',
                 backgroundColor: 'var(--color-info-light)',
                 borderColor: 'var(--color-info)',
                 marginBottom: 'var(--space-3)'
               }}>
            <i className="bi bi-info-circle me-2"></i>
            Puedes programar recordatorios para este proveedor desde la sección de recordatorios.
          </div>
          <button 
            className="btn btn-secondary transition-base" 
            onClick={onCancel}
            style={{
              fontSize: 'var(--font-size-sm)',
              padding: 'var(--space-2) var(--space-3)'
            }}
          >
            Cerrar
          </button>
        </div>
      </div>
    );
  }

  // Formulario normal
  return (
    <div className="card mb-3 card-elevated" 
         style={{borderRadius: 'var(--radius-xl)'}}>
      <div className="modal-header-gradient">
        <h5 className="mb-0">
          <i className="bi bi-person-plus me-2"></i>
          {isExisting ? "Editar Proveedor" : "Agregar Proveedor de Servicios"}
        </h5>
      </div>

      <div className="card-body" 
           style={{padding: 'var(--space-4)'}}>
        <div className="alert alert-info rounded-lg mb-3"
             style={{
               fontSize: 'var(--font-size-sm)',
               padding: 'var(--space-3)',
               borderRadius: 'var(--radius-md)',
               backgroundColor: 'var(--color-info-light)',
               borderColor: 'var(--color-info)'
             }}>
          <i className="bi bi-info-circle me-2"></i>
          Al agregar un proveedor con correo, se le enviará una invitación para que pueda recibir recordatorios automáticos.
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label"
                   style={{
                     fontSize: 'var(--font-size-sm)',
                     fontWeight: 'var(--font-weight-semibold)',
                     color: 'var(--gray-700)'
                   }}>
              Nombre <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              placeholder="Ej. Juan Pérez"
              required
              style={{
                fontSize: 'var(--font-size-sm)',
                borderRadius: 'var(--radius-md)',
                borderColor: 'var(--gray-300)',
                padding: 'var(--space-2)'
              }}
            />
          </div>

          <div className="mb-3">
            <label className="form-label"
                   style={{
                     fontSize: 'var(--font-size-sm)',
                     fontWeight: 'var(--font-weight-semibold)',
                     color: 'var(--gray-700)'
                   }}>
              Tipo de Servicio <span className="text-danger">*</span>
            </label>
            <select 
              className="form-select"
              name="tipoServicio"
              value={formData.tipoServicio}
              onChange={handleChange}
              required
              style={{
                fontSize: 'var(--font-size-sm)',
                borderRadius: 'var(--radius-md)',
                borderColor: 'var(--gray-300)',
                padding: 'var(--space-2)'
              }}
            >
              <option value="paseador">🚶 Paseador</option>
              <option value="bañador">🛁 Servicio de Baño</option>
              <option value="cuidador">🏠 Cuidador</option>
              <option value="transporte">🚗 Transporte</option>
              <option value="alimentacion">🍖 Alimentación</option>
              <option value="otro">📋 Otro</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label"
                   style={{
                     fontSize: 'var(--font-size-sm)',
                     fontWeight: 'var(--font-weight-semibold)',
                     color: 'var(--gray-700)'
                   }}>
              Correo Electrónico
              <small className="text-muted ms-2"
                     style={{fontSize: 'var(--font-size-xs)'}}>
                (Opcional - para enviar invitación)
              </small>
            </label>
            <input
              className="form-control"
              type="email"
              name="correo"
              value={formData.correo}
              onChange={handleChange}
              placeholder="proveedor@email.com"
              style={{
                fontSize: 'var(--font-size-sm)',
                borderRadius: 'var(--radius-md)',
                borderColor: 'var(--gray-300)',
                padding: 'var(--space-2)'
              }}
            />
            {!formData.correo && (
              <small className="text-muted"
                     style={{fontSize: 'var(--font-size-xs)'}}>
                Si no proporcionas correo, no se enviará invitación pero podrás agregarlo después.
              </small>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label"
                   style={{
                     fontSize: 'var(--font-size-sm)',
                     fontWeight: 'var(--font-weight-semibold)',
                     color: 'var(--gray-700)'
                   }}>
              Teléfono
              <small className="text-muted ms-2"
                     style={{fontSize: 'var(--font-size-xs)'}}>
                (Opcional)
              </small>
            </label>
            <input
              className="form-control"
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              placeholder="229-123-4567"
              style={{
                fontSize: 'var(--font-size-sm)',
                borderRadius: 'var(--radius-md)',
                borderColor: 'var(--gray-300)',
                padding: 'var(--space-2)'
              }}
            />
          </div>

          <div className="d-flex gap-2"
               style={{gap: 'var(--space-2)'}}>
            <button 
              type="submit" 
              className="btn btn-feature transition-base"
              style={{
                fontSize: 'var(--font-size-sm)',
                fontWeight: 'var(--font-weight-semibold)',
                padding: 'var(--space-2) var(--space-3)'
              }}
            >
              <i className="bi bi-save me-2"></i>
              {isExisting ? "Actualizar" : "Agregar Proveedor"}
            </button>
            <button 
              type="button" 
              className="btn btn-secondary transition-base" 
              onClick={onCancel}
              style={{
                fontSize: 'var(--font-size-sm)',
                padding: 'var(--space-2) var(--space-3)'
              }}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}